// extracted by mini-css-extract-plugin
module.exports = {"notices":"Notices_notices__0TlNG","notices--desktop":"Notices_notices--desktop__dr9nT"};